'use client'

import { algoliaAnalytics, algoliaAppId, algoliaApiKey } from 'algolia/algolia'
import * as React from 'react'
import { useIsLoggedInQuery, useUserIdQuery } from 'auth/hooks'

export function AlgoliaAnalytics() {
  // eslint-disable-next-line cf-web/codegen-query-patterns
  const isUserLoggedIn = useIsLoggedInQuery()
  const { data: userId } = useUserIdQuery()

  React.useEffect(() => {
    algoliaAnalytics('init', {
      appId: algoliaAppId,
      apiKey: algoliaApiKey,
    })
  }, [])

  React.useEffect(() => {
    if (isUserLoggedIn.data) {
      algoliaAnalytics('setUserToken', `user-${userId}`)
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserLoggedIn.data, userId])

  return <></>
}
